import RowGenericSlice from "./tableRow";

const suspiciousRowSlice = RowGenericSlice('suspicious');

export const {addRow,removeRow, setRows } = suspiciousRowSlice.actions

export default suspiciousRowSlice.reducer;